import React from "react";
import { BannerCarusel, BannerCaruselProps } from "./BannerCarusel";

export interface BannerImageInfo {
  url: string;
  width: number;
}

interface BannerLoaderProps {
  url: string;
  getparentHeight : ()=>number;
}

interface BannerLoaderState {
  isReady: boolean;
  bannerConfig: BannerCaruselProps|undefined;
}

export class BannerLoader extends React.Component<
  BannerLoaderProps,
  BannerLoaderState
> {
  constructor(props: BannerLoaderProps) {
    super(props);
    this.state = { isReady: false, bannerConfig:undefined };
  }

  componentDidMount() {
    fetch(this.props.url)
      .then(response => response.json())
      .then(data => this.setState({ bannerConfig:data }));
  }

  render() {
    return (
      <div className="BannerLoader">
        {this.state.bannerConfig !== undefined ? (
          <BannerCarusel
            baseUrl={this.state.bannerConfig.baseUrl}
            items={this.state.bannerConfig.items}
            switchTime={this.state.bannerConfig.switchTime}
            animateInterval={this.state.bannerConfig.animateInterval}
            animateStep={this.state.bannerConfig.animateStep}
            getparentHeight={this.props.getparentHeight}
          ></BannerCarusel>
        ) : null}
      </div>
    );
  }
}
